import React from 'react';
import BackButton from '../components/BackButton';
import TheIntegral from '../components/TheIntegral';

function TheIntegralPage() {
  return (
    <>
      <BackButton />
      <TheIntegral />
    </>
  );
}

export default TheIntegralPage;
